import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../../store/authStore';
import { useChatStore } from '../../../store/chat_store';
import { getConversations, getMessages } from '../../../services/chat_service';
import ChatLayout from '../components/ChatLayout';
import ChatSidebar from '../components/ChatSidebar';
import ChatHeader from '../components/ChatHeader';
import MessageList from '../components/MessageList';
import MessageInput from '../components/MessageInput';
import api from '../../../services/api'; // to fetch users initially if needed

export const ChatPage = () => {
  const { user } = useAuthStore();
  const { initSocket, disconnectSocket, setConversations, activeConversation, setMessages } = useChatStore();
  const [users, setUsers] = useState([]); // All users in the system for starting new chats

  useEffect(() => {
    if (user) {
      initSocket(user.id);
      fetchInitialData();
    }
    return () => {
      disconnectSocket();
    };
  }, [user, initSocket, disconnectSocket]);

  useEffect(() => {
    if (activeConversation) {
      loadMessages(activeConversation.otherUserId);
    }
  }, [activeConversation]);

  const fetchInitialData = async () => {
    try {
      // Fetch existing conversations
      const resConv = await getConversations();
      if (resConv.status === 'success') {
        setConversations(resConv.data);
      }
      
      // Fetch all users to populate sidebar for new chats (assumes a /users endpoint exists)
      const resUsers = await api.get('/teams'); // typically teams/users
      if (resUsers.data?.status === 'success') {
        setUsers(resUsers.data.data.users || resUsers.data.data); // Adjust based on your API response
      }
    } catch (error) {
      console.error('Failed to load chat data', error);
    }
  };

  const loadMessages = async (otherUserId) => {
    try {
      const res = await getMessages(otherUserId);
      if (res.status === 'success') {
        setMessages(res.data.messages);
        useChatStore.setState({ 
          activeConversation: { 
            ...useChatStore.getState().activeConversation, 
            conversationId: res.data.conversation_id 
          } 
        });
      }
    } catch (error) {
      console.error('Failed to load messages', error);
    }
  };

  return (
    <ChatLayout>
      <ChatSidebar users={users} />
      <div className="flex-1 flex flex-col h-full bg-white">
        {activeConversation ? (
          <>
            <ChatHeader />
            <MessageList />
            <MessageInput />
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center text-gray-400 bg-gray-50 h-full">
            Select a conversation or user to start chatting
          </div>
        )}
      </div>
    </ChatLayout>
  );
};

export default ChatPage;
